var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2318_8417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33192 1.99653H6.25304C5.7015 1.99653 5.25477 1.5498 5.25477 0.998264C5.25477 0.446723 5.7015 0 6.25304 0H8.33192C8.88346 0 9.33019 0.446723 9.33019 0.998264C9.33019 1.5498 8.88346 1.99653 8.33192 1.99653ZM22.682 4.21018C23.1861 3.98557 23.4132 3.39659 23.1911 2.89247C22.9465 2.34342 22.6096 1.84928 22.1853 1.42502C21.2694 0.506619 20.0515 0 18.7538 0H18.342C17.7905 0 17.3437 0.446723 17.3437 0.998264C17.3437 1.5498 17.7905 1.99653 18.342 1.99653H18.7538C19.5175 1.99653 20.2337 2.29351 20.7728 2.83507C21.0224 3.08464 21.2245 3.37663 21.3668 3.70106C21.5315 4.07292 21.8958 4.29503 22.2802 4.29503C22.4149 4.29503 22.5522 4.26758 22.6845 4.21018H22.682ZM14.5286 8.70736C14.5286 8.15582 14.0819 7.70909 13.5304 7.70909H6.55751C6.00597 7.70909 5.55924 8.15582 5.55924 8.70736C5.55924 9.2589 6.00597 9.70562 6.55751 9.70562H13.5304C14.0819 9.70562 14.5286 9.2589 14.5286 8.70736ZM23.6029 18.997C23.6029 18.4454 23.1561 17.9987 22.6046 17.9987H10.8226C10.271 17.9987 9.82433 18.4454 9.82433 18.997C9.82433 19.5485 10.271 19.9952 10.8226 19.9952H22.6046C23.1561 19.9952 23.6029 19.5485 23.6029 18.997ZM8.61393 18.997C8.61393 18.4454 8.16721 17.9987 7.61567 17.9987H6.52756C4.24154 17.9987 2.38227 16.1394 2.38227 13.8534C2.38227 12.7453 2.81402 11.7046 3.59766 10.921C3.75738 10.7613 3.92209 10.6215 4.08681 10.5017C4.53602 10.1798 4.63835 9.55838 4.31641 9.10916C3.99447 8.65994 3.37305 8.55762 2.92383 8.87956C2.66927 9.06174 2.4197 9.27387 2.18511 9.50846C1.02463 10.6689 0.385742 12.2113 0.385742 13.8534C0.385742 17.24 3.14095 19.9952 6.52756 19.9952H7.61567C8.16721 19.9952 8.61393 19.5485 8.61393 18.997ZM23.1362 6.93294C23.3733 6.43381 23.1611 5.83984 22.662 5.60276C22.1629 5.36567 21.5689 5.5778 21.3318 6.07693C20.8601 7.0702 19.8469 7.71159 18.7488 7.71159H16.7323C16.1808 7.71159 15.734 8.15831 15.734 8.70985C15.734 9.26139 16.1808 9.70812 16.7323 9.70812H18.7488C20.6131 9.70812 22.3351 8.62001 23.1337 6.93544L23.1362 6.93294ZM16.1309 0.998264C16.1309 0.446723 15.6841 0 15.1326 0H11.5388C10.9873 0 10.5406 0.446723 10.5406 0.998264C10.5406 1.5498 10.9873 1.99653 11.5388 1.99653H15.1326C15.6841 1.99653 16.1309 1.5498 16.1309 0.998264Z",
    fill: "url(#paint0_linear_2318_8417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.6046 23.0002C24.8154 23.0002 26.6076 21.208 26.6076 18.9972C26.6076 16.7864 24.8154 14.9941 22.6046 14.9941C20.3938 14.9941 18.6016 16.7864 18.6016 18.9972C18.6016 21.208 20.3938 23.0002 22.6046 23.0002Z",
    fill: "#50D049"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2318_8417",
    x1: 0.385742,
    y1: 9.99761,
    x2: 23.6029,
    y2: 9.99761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50D049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC435"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2318_8417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.2219,
    height: 23,
    fill: "white",
    transform: "translate(0.385742)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer1);
export default __webpack_public_path__ + "static/media/Layer_1.afc6bb060b1f7ea2255de57e36e5eea4.svg";
export { ForwardRef as ReactComponent };